import { render, staticRenderFns } from "./ImageHistoryTable.vue?vue&type=template&id=a806e590&"
import script from "./ImageHistoryTable.vue?vue&type=script&lang=js&"
export * from "./ImageHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports